//// Application Configuration
import React from 'react'
import { Link } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'

//// Application Modules

//// Application Slices
import { selectSettings } from '../../reducers/settingSlice'

//// Application Components

//// Carbon Components
import { Breadcrumb, BreadcrumbItem } from '@carbon/react'

//////////////// Component
const BreadcrumbComponent = () => {
    //////// Hooks
    const location = useLocation()
    const { pathname } = location

    //////// State

    //////// Slices
    const settingsData = useSelector(selectSettings)

    //// Slice Data
    const page_category_digital_name =
        settingsData?.['page']?.['category_digital_name']
    const page_category_written_name =
        settingsData?.['page']?.['category_written_name']
    const page_category_route = settingsData?.['page']?.['category_route']
    const page_digital_name = settingsData?.['page']?.['digital_name']
    const page_written_name = settingsData?.['page']?.['written_name']
    const page_current_route = settingsData?.['page']?.['current_route']
    const page_previous_route = settingsData?.['page']?.['previous_route']
    const form_category_digital_name =
        settingsData?.['form']?.['category_digital_name']
    const form_category_written_name =
        settingsData?.['form']?.['category_written_name']
    const form_category_route = settingsData?.['form']?.['category_route']
    const form_digital_name = settingsData?.['form']?.['digital_name']
    const form_written_name = settingsData?.['form']?.['written_name']
    const form_current_route = settingsData?.['form']?.['current_route']
    const form_previous_route = settingsData?.['form']?.['previous_route']

    //////// Search Params

    //////// Methods

    //////// Functional Methods

    //////// Memoization

    //////// Effects/Side Effects

    //////////////// Render & Return
    if (
        pathname.includes(page_digital_name) &&
        page_category_digital_name &&
        page_category_written_name &&
        page_category_route &&
        page_digital_name &&
        page_written_name &&
        page_current_route &&
        page_previous_route === '/'
    ) {
        return (
            <>
                <div className="page-breadcrumb">
                    <Breadcrumb>
                        <BreadcrumbItem>
                            <Link to={page_category_route}>
                                {page_category_written_name}
                            </Link>
                        </BreadcrumbItem>
                        <BreadcrumbItem>
                            <Link to={page_category_route}>
                                {page_written_name}
                            </Link>
                        </BreadcrumbItem>
                    </Breadcrumb>
                </div>
            </>
        )
    } else if (
        pathname.includes(form_digital_name) &&
        form_category_digital_name &&
        form_category_written_name &&
        form_category_route &&
        form_digital_name &&
        form_written_name &&
        form_current_route &&
        form_previous_route === '/'
    ) {
        return (
            <>
                <div className="page-breadcrumb">
                    <Breadcrumb>
                        <BreadcrumbItem>
                            <Link to={form_category_route}>
                                {form_category_written_name}
                            </Link>
                        </BreadcrumbItem>
                        <BreadcrumbItem>
                            <Link to={form_category_route}>
                                {form_written_name}
                            </Link>
                        </BreadcrumbItem>
                    </Breadcrumb>
                </div>
            </>
        )
    } else if (
        pathname.includes(page_digital_name) &&
        page_category_digital_name &&
        page_category_written_name &&
        page_category_route &&
        page_digital_name &&
        page_written_name &&
        page_current_route
    ) {
        return (
            <>
                <div className="page-breadcrumb">
                    <Breadcrumb>
                        <BreadcrumbItem>
                            <Link to={page_category_route}>
                                {page_category_written_name}
                            </Link>
                        </BreadcrumbItem>
                        <BreadcrumbItem>
                            <Link to={page_category_route + page_current_route}>
                                {page_written_name}
                            </Link>
                        </BreadcrumbItem>
                    </Breadcrumb>
                </div>
            </>
        )
    } else if (
        pathname.includes(form_digital_name) &&
        form_category_digital_name &&
        form_category_written_name &&
        form_category_route &&
        form_digital_name &&
        form_written_name &&
        form_current_route
    ) {
        return (
            <>
                <div className="page-breadcrumb">
                    <Breadcrumb>
                        <BreadcrumbItem>
                            <Link to={form_category_route}>
                                {form_category_written_name}
                            </Link>
                        </BreadcrumbItem>
                        <BreadcrumbItem>
                            <Link to={form_category_route + form_current_route}>
                                {form_written_name}
                            </Link>
                        </BreadcrumbItem>
                    </Breadcrumb>
                </div>
            </>
        )
    } else if (
        pathname.includes(page_category_digital_name) &&
        page_category_digital_name &&
        page_category_written_name &&
        page_category_route
    ) {
        return (
            <>
                <div className="page-breadcrumb">
                    <Breadcrumb>
                        <BreadcrumbItem>
                            <Link to={page_category_route}>
                                {page_category_written_name}
                            </Link>
                        </BreadcrumbItem>
                    </Breadcrumb>
                </div>
            </>
        )
    } else if (
        pathname.includes(form_category_digital_name) &&
        form_category_digital_name &&
        form_category_written_name &&
        form_category_route
    ) {
        return (
            <>
                <div className="page-breadcrumb">
                    <Breadcrumb>
                        <BreadcrumbItem>
                            <Link to={form_category_route}>
                                {form_category_written_name}
                            </Link>
                        </BreadcrumbItem>
                    </Breadcrumb>
                </div>
            </>
        )
    } else {
        return <></>
    }
}

export default BreadcrumbComponent
